const ATTRIBUTE_KEY_PURGE_GROUPS = [
  new Set(['civil_status', 'civilStatus', 'marital_status']),
  new Set(['geographic_area_of_residence', 'residence', 'area']),
  new Set(['occupation', 'job_title']),
  new Set(['qualification', 'education_level']),
  new Set(['income', 'annual_income']),
  new Set(['personal_interests', 'personalInterests', 'Personal Interests']),
  new Set(['first_name', 'name']),
  new Set(['last_name', 'surname']),
  new Set(['years_of_service', 'yearsOfService']),
];

export function keysToPurge(attributeKey, previousKeys = []) {
  const keys = new Set();
  if (attributeKey) keys.add(attributeKey);
  (previousKeys || []).forEach((legacyKey) => {
    if (legacyKey) keys.add(legacyKey);
  });
  if (!keys.size) return [];

  for (const group of ATTRIBUTE_KEY_PURGE_GROUPS) {
    for (const key of keys) {
      if (group.has(key)) {
        return [...group].sort();
      }
    }
  }
  return [...keys].sort();
}

function valuePresent(value) {
  if (value == null) return false;
  if (typeof value === 'string' && value.trim() === '') return false;
  if (Array.isArray(value) && value.length === 0) return false;
  if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) {
    return false;
  }
  return true;
}

function hasAttributeValue(data, keys) {
  if (!data || typeof data !== 'object') return false;

  for (const key of keys) {
    if (Object.prototype.hasOwnProperty.call(data, key) && valuePresent(data[key])) {
      return true;
    }
    for (const nest of ['personal_characteristics', 'personalCharacteristics']) {
      const nested = data[nest];
      if (nested && Object.prototype.hasOwnProperty.call(nested, key) && valuePresent(nested[key])) {
        return true;
      }
    }
  }
  return false;
}

export function countPersonasWithAttributeValue(personaDocs, attributeKey, previousKeys = []) {
  const keys = keysToPurge(attributeKey, previousKeys);
  if (!keys.length) return 0;

  let count = 0;
  for (const doc of personaDocs || []) {
    if (hasAttributeValue(doc?.data, keys)) {
      count += 1;
    }
  }
  return count;
}
